import React from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import AppNavbar from "../../../components/common/AppNavbar";

const CanadaImmigrationReset2026 = () => {
  return (
    <>
      <AppNavbar />
      <div style={{ background: "#f4f7fb" }}>
        {/* HERO SECTION */}
        <div
          style={{
            background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
            color: "white",
            padding: "60px 0",
          }}
        >
          <Container>
            <Badge bg="light" text="dark" className="mb-3">
              Immigration Reset Feb 2026
            </Badge>
            <h1 className="fw-bold">Canada’s 2026 Immigration Reset</h1>
            <p className="lead mt-3" style={{ maxWidth: "900px" }}>
              Canada shifts from high-volume migration to a tightly controlled,
              skills-driven model — with major impacts on Indian/Bharat students
              and workers.
            </p>
          </Container>
        </div>

        <section class="immigration-article">
          <div class="container py-5">
            <h2>Canada Immigration Reforms 2026–2028: A Major Reset</h2>

            <p>
              The reforms were introduced through the{" "}
              <strong>2026–2028 Immigration Levels Plan</strong>, aiming to
              reduce Canada’s temporary resident population to below{" "}
              <strong>5% of the total population by 2027</strong>.
            </p>

            <p>
              This marks a major recalibration of study permits, work
              authorizations, and permanent residency pathways. These changes
              carry acute consequences for Indian/Bharat nationals, who make up
              one of Canada’s largest student and immigrant cohorts.
            </p>

            <hr />

            <h3>Study Permit Cuts Hit Indian/Bharat Students the Hardest</h3>

            <p>Canada has slashed study permits to historically low levels.</p>

            <ul>
              <li>
                The federal plan sets{" "}
                <strong>155,000 new study permits for 2026</strong>, a dramatic
                drop from past years.
              </li>
              <li>
                Some analysts estimate a <strong>30% reduction</strong>, with
                allocations falling to roughly{" "}
                <strong>408,000 across all categories</strong>.
              </li>
              <li>
                Indian/Bharat students, previously over{" "}
                <strong>40% of all international students</strong>, face the
                steepest decline.
              </li>
              <li>
                Refusal rates for Indian/Bharat applicants surged to{" "}
                <strong>74% in 2025</strong>, signaling tighter admissibility
                standards ahead.
              </li>
            </ul>

            <h4>Key Student Visa Changes</h4>
            <ul>
              <li>
                <strong>50%+ reduction in permits</strong> disproportionately
                affects Indian applicants in Ontario and British Columbia.
              </li>
              <li>
                <strong>Master’s & PhD researchers</strong> exempt from
                Provincial Attestation Letters (PAL), accelerating processing
                for high-skilled academics.
              </li>
              <li>
                <strong>Higher financial thresholds</strong> increase the cost
                burden on Indian families.
              </li>
            </ul>

            <hr />

            <h3>Spousal Work Permits Restriction Limits Family Mobility</h3>

            <p>
              Spousal Open Work Permits (SOWP) are now limited to spouses of:
            </p>

            <ul>
              <li>
                <strong>PhD students</strong>, and
              </li>
              <li>
                <strong>Certain master’s students</strong> (programs ≥16
                months).
              </li>
            </ul>

            <p>
              This severely restricts Indian/Bharat national families’ ability
              to work and settle in Canada while one partner studies, marking a
              reversal from previously liberal spousal work authorization
              policies.
            </p>

            <hr />

            <h3>Start-Up Visa (SUV) Program Closed to New Applicants</h3>

            <p>
              Canada has suspended the <strong>Start-Up Visa (SUV)</strong>{" "}
              program for all applicants without a 2025 commitment certificate,
              ending a key permanent residency route used by Indian tech
              entrepreneurs.
            </p>

            <p>
              A new “entrepreneur pilot” is expected later in 2026, though
              details remain unannounced.
            </p>

            <hr />

            <h3>
              Express Entry Overhauled: Priority for French Speakers & Canadian
              Experience
            </h3>

            <p>Express Entry has been reshaped to favor:</p>

            <ul>
              <li>French-speaking candidates,</li>
              <li>Applicants with Canadian work experience,</li>
              <li>
                High-demand professions like healthcare, STEM, and skilled
                trades.
              </li>
            </ul>

            <p>
              <strong>
                For Indian/Bharat national applicants, this means:
              </strong>
            </p>

            <ul>
              <li>Lower chances without French proficiency,</li>
              <li>
                Disadvantages for applicants applying directly from India with
                no Canadian experience,
              </li>
              <li>
                Increased competition in category-based draws targeting narrow
                occupational groups.
              </li>
            </ul>

            <p>
              Canada plans for <strong>64% of all PR admissions by 2027</strong>{" "}
              to come from economic streams, further solidifying its
              skills-first approach.
            </p>

            <hr />

            <h3>Temporary Resident Reductions Shrink Future Pathways</h3>

            <p>To curb reliance on temporary migration, Canada will:</p>

            <ul>
              <li>
                Cap temporary residents at <strong>385,000 for 2026</strong>,
                and
              </li>
              <li>
                Reduce temporary admissions to{" "}
                <strong>under 5% of the population by 2027</strong>.
              </li>
            </ul>

            <p>
              <strong>For Indian/Bharat nationals, this means fewer:</strong>
            </p>

            <ul>
              <li>Study permits,</li>
              <li>Temporary foreign worker positions,</li>
              <li>Transition routes from temporary to permanent residency.</li>
            </ul>

            <p>
              This marks a dramatic departure from Canada’s previously open and
              flexible migration model.
            </p>

            <hr />

            <h3>Summary</h3>

            <p>
              Canada’s 2026 reforms usher in a new era of selectivity,
              emphasizing high-skilled applicants, French speakers, and those
              with Canadian work experience.
            </p>

            <p>
              Indian/Bharat nationals — long central to Canada’s student and
              workforce pipelines — now face:
            </p>

            <ul>
              <li>Severe reductions in study permits</li>
              <li>Restricted spousal work rights</li>
              <li>Fewer temporary worker pathways</li>
              <li>Higher refusal rates and financial barriers</li>
              <li>More competitive, skills-based PR pathways</li>
            </ul>

            <p>
              While opportunities remain for top-tier talent and researchers,
              Canada’s once-wide immigration door is narrowing, shifting toward
              a model that rewards only the most competitive,
              labor-market-aligned applicants.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default CanadaImmigrationReset2026;
